module.exports = __webpack_public_path__ + "img/chadle_adv_01.78b98c39.png";